import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { masterServices } from 'src/app/module/master/services/ems-services.service';
import { ordersService } from '../../services/orders.service';
import { MessageService } from 'primeng/api';
import { staticStatusList } from 'src/app/constants/constants/constants';

export interface TruckComponent  {
  id: number;
  type: 'Tyre' | 'Battery' | 'Insurance' | 'Pollution';
  serialNo: string;
  associatedFrom: string;
  kmAtAssociation: number;
  kmRunSoFar: number;
}

@Component({
  selector: 'app-remove-component',
  templateUrl: './remove-component.component.html',
  styleUrls: ['./remove-component.component.css'],
})
export class RemoveComponentComponent implements OnInit{
  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<{
    component: TruckComponent;
    toDate: string;
    kmAtRemoval: string;
  }>();
  statusList = [
  { value: 'Idle', label: 'Idle' },
  { value: 'Retired', label: 'Retired' },
  { value: 'Damaged', label: 'Damaged' },
  { value: 'InRepair', label: 'InRepair' },
  { value: 'Lost', label: 'Lost' },
  // { value: 'Parked', label: 'Parked' },
  // { value: 'Broken', label: 'Broken' },
  { value: 'Expired', label: 'Expired' }
  ]
deAssociationDate:any;
deAssociationkm:any;
deAssociationStatus:any;
  selectedComponents: any;

  selectedComponent:any;
  toDate = '';
  kmAtRemoval = '';
  truckDetails: any;
  truckTranscations: any;
  statusCount: any;
 maxDate: Date = new Date();
 searchText: string = '';
filteredTransactions: any[] = [];
constructor(
  public dialogRef: DynamicDialogRef,
      private datePipe: DatePipe,
      public data: DynamicDialogConfig,
      private masterServices: masterServices,
      private ordersService: ordersService,
      private messageService: MessageService
){
  console.log("data",data)

  this.truckDetails = data?.data?.data


  this.getTruckBuildById(this.truckDetails?.id)
    

}
ngOnInit() {
}
  onClose(): void {
    this.closed.emit();
  }
getTruckBuildById(id: any) {
  this.ordersService.getTruckBuildById(id).subscribe((res: any) => {
    // this.truckDetails = res?.responseObject;   
    this.truckTranscations = res?.responseObject?.component

    //   if( data?.data?.truckTranscations){
    // this.truckTranscations = data?.data?.truckTranscations;
    
  // this.truckTranscations = this.truckTranscations.filter(
  //   (item: any) => item.status === 'Live'
  // );

  // const statusCount: any = {};

  // this.truckTranscations.forEach((item: any) => {
  //     const status = item.status;
  //     if (!statusCount[status]) {
  //       statusCount[status] = 0;
  //     }
  //     statusCount[status]++;
  //   });
  //   this.statusCount = statusCount
    console.log(res);
    console.log(this.truckTranscations);
  this.filteredTransactions = [...this.truckTranscations];

  if (this.truckDetails?.insuranceNumber) {
      this.filteredTransactions.push({
        id: 'Insurance_' + Date.now(),
        componentType: 'Insurance',
        associationType: 'Insurance',
        serialNumber: this.truckDetails.insuranceNumber,
        purchaseDate: this.truckDetails.insuranceValidityFrom,
        totalKmTravelled: '',
        insurerId: this.truckDetails.insurerId,
        insuranceValidityFrom: this.truckDetails.insuranceValidityFrom,
        insuranceValidityTill: this.truckDetails.insuranceValidityTill,
        insuranceUrl: this.truckDetails.insuranceUrl,
        insuranceNumber: this.truckDetails.insuranceNumber,
      });
    }
    if (this.truckDetails?.pucId) {
      this.filteredTransactions.push({
        id: 'puc_' + Date.now(),
        componentType: 'PUC',
        associationType: 'PUC',
        serialNumber: this.truckDetails.puc,
        purchaseDate: this.truckDetails.pucValidityFrom,
        totalKmTravelled: '',
        pucId: this.truckDetails.pucId,
        puc: this.truckDetails.puc,
        pucValidityFrom: this.truckDetails.pucValidityFrom,
        pucValidityTill: this.truckDetails.pucValidityTill,
        pucUrl: this.truckDetails.pucUrl,
      });
      }
    //   if (this.truckDetails?.vendorId) {
    //   this.filteredTransactions.push({
    //     id: 'Dealer_' + Date.now(),
    //     componentType: 'Dealer',
    //     associationType: 'Dealer',
    //     serialNumber: this.truckDetails.vendorCode,
    //     purchaseDate: this.truckDetails.vendorValidityFrom,
    //     totalKmTravelled: '',
    //     vendorId: this.truckDetails.vendorId,
    //     vendorName: this.truckDetails.vendorName,
    //     vendorValidityFrom: this.truckDetails.vendorValidityFrom,
    //     vendorValidityTill: this.truckDetails.vendorValidityTill,
    //     vendorUrl: this.truckDetails.vendorUrl,
    //   });
    // }

  // }

  })
}

toggleSelection(item: any) {
  if (this.selectedComponent?.id === item.id) {
    this.selectedComponent = null; // unselect
  } else {
    this.selectedComponent = this.selectedComponent === item ? null : item;; // select new
  }
  console.log(this.selectedComponent)
}

isSelected(item: any) {
  return this.selectedComponent?.id === item.id;
}

  getBadgeClass(type: string) {
    switch (type) {
      case 'Tyre':
        return 'badge-tyre';

      case 'Battery':
        return 'badge-battery';

      case 'Insurance':
        return 'badge-insurance';

      case 'PUC':
        return 'badge-pollution';

      default:
        return '';
    }
  }

  removeBuildComponent() {
    console.log(this.selectedComponent)
    console.log(this.truckDetails);

    let associatedTyres = this.truckDetails?.associatedTyres || 0;
    let associatedTrailerTyres = this.truckDetails?.associatedTrailerTyres || 0;
    let associatedBatteries = this.truckDetails?.associatedBatteries || 0;

    if (this.selectedComponent?.componentType === "Tyre" 
      && this.selectedComponent?.associationType === "TRUCK"
      ) {
      associatedTyres = associatedTyres - 1;
    }

    if (this.selectedComponent?.componentType === "Tyre" &&
        this.selectedComponent?.associationType === "TRAILER") {
      associatedTrailerTyres = associatedTrailerTyres - 1;
    }

    if (this.selectedComponent?.componentType === "Battery") {
      associatedBatteries = associatedBatteries - 1;
    }
     let payload: any;
     if(this.selectedComponent?.associationType == 'PUC'){
      payload = {
        id: this.truckDetails?.id,
        isPuc: false,
        'initialKmTravelled':this.deAssociationkm,
        }
     }else if(this.selectedComponent?.associationType == 'Insurance'){
        payload = {
          id: this.truckDetails?.id,
          isInsurance: false,
          'initialKmTravelled':this.deAssociationkm,
        }
     }else{
      payload = {
      id: this.truckDetails?.id,
      associatedTyres: associatedTyres,
      associatedTrailerTyres: associatedTrailerTyres,
      associatedBatteries: associatedBatteries,
      'initialKmTravelled':this.deAssociationkm,
      commponentAssociation:
          [
            {
            componentType:this.selectedComponent?.componentType,
            oldComponentKms:this.deAssociationkm,
            oldComponentToDate:this.deAssociationDate ? this.datePipe.transform(this.deAssociationDate, 'dd-MM-yyyy HH:mm:ss Z')  : null,
            oldComponentStatus:this.deAssociationStatus ,
            oldComponentId: this.selectedComponent.id,
            oldComponentVersion: this.selectedComponent?.version ?? null,
            // oldComponentStatus: 0
          }
        ],
    };
    }
    console.log(payload)
    this.ordersService.getBuild(payload).subscribe((data: any) => {
      if (data) {
        console.log(data)
        this.dialogRef.close(data);
      }
    })
  
  }

  close(){
    this.dialogRef.close('data');
  }

  filterData() {
  const search = this.searchText.toLowerCase();

  this.filteredTransactions = this.truckTranscations.filter((item:any) =>
    (item.componentType?.toLowerCase().includes(search)) ||
    (item.associationType?.toLowerCase().includes(search)) ||
    (item.serialNumber?.toLowerCase().includes(search)) ||
    (item.totalKmTravelled?.toString().includes(search))
  );
}

onDateSelect(selectedDate: Date) {
  if (!selectedDate) return;
  const now = new Date();
  selectedDate.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  this.deAssociationDate = new Date(selectedDate);
}

}
